import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const ListPage = lazy(() => import('@/features/workers/list/page'));
const ScheduledInterviewsPage = lazy(
  () => import('@/features/workers/scheduled/page')
);
const AdvancedSearchPage = lazy(() => import('@/features/workers/search/page'));
const UnifiedListPage = lazy(() => import('@/features/workers/unified/page'));
const CreatePage = lazy(() => import('@/features/workers/create/page'));
const WorkerLayout = lazy(() => import('@/features/workers/info/WorkerLayout'));
const InfoPage = lazy(() => import('@/features/workers/info/page'));
const DependantsPage = lazy(() => import('@/features/workers/dependants/page'));
const VehiclesPage = lazy(() => import('@/features/workers/vehicles/page'));
const LicensesPage = lazy(() => import('@/features/workers/licenses/page'));
const MedicalExamsPage = lazy(() => import('@/features/workers/medical-exams/page'));
const PreExistingConditionsPage = lazy(
  () => import('@/features/workers/pre-existing-conditions/page')
);
const EmploymentPeriodsPage = lazy(() => import('@/features/workers/employment-periods/page'));
const CompanyInterviewsPage = lazy(() => import('@/features/workers/company-interviews/page'));
const ContactLogsPage = lazy(() => import('@/features/workers/contact-logs/page'));
const DriverLicenseCategoriesPage = lazy(
  () => import('@/features/workers/driver-license-categories/page')
);

export const workersRoutes: RouteObject[] = [
  { path: 'workers', element: <ListPage /> },
  { path: 'workers/scheduled-interviews', element: <ScheduledInterviewsPage /> },
  { path: 'workers/search', element: <AdvancedSearchPage /> },
  { path: 'workers/unified', element: <UnifiedListPage /> },
  { path: 'workers/new', element: <CreatePage /> },
  {
    path: 'workers/:id',
    element: <WorkerLayout />,
    children: [
      { index: true, element: <InfoPage /> },
      { path: 'dependants', element: <DependantsPage /> },
      { path: 'vehicles', element: <VehiclesPage /> },
      { path: 'licenses', element: <LicensesPage /> },
      { path: 'driver-license-categories', element: <DriverLicenseCategoriesPage /> },
      { path: 'medical-exams', element: <MedicalExamsPage /> },
      { path: 'pre-existing-conditions', element: <PreExistingConditionsPage /> },
      { path: 'employment-periods', element: <EmploymentPeriodsPage /> },
      { path: 'company-interviews', element: <CompanyInterviewsPage /> },
      { path: 'contact-logs', element: <ContactLogsPage /> },
    ],
  },
];
